import Button from "@/components/base/Button";
import { MAPS_LINK } from "@/pages/home/constants";

export default function Hero() {
  return (
    <section id="inicio" className="relative w-full overflow-hidden">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://storage.helloreaddy.io/project_files/8ede1629-48ad-4015-89eb-b95dfff38e03/b4fc3b06-159f-41e1-a57b-baae65279368_compressed_interior-tienda-iokus-guatape.webp"
          alt="Interior del punto de venta de Iokus en Guatapé con juegos de mesa y juguetes de madera"
          title="Iokus Guatapé juegos de mesa y juguetes de madera en el Museo del Zócalo"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-content flex-col items-center justify-center px-4 pb-20 pt-32 text-center md:px-6 md:pb-28 md:pt-40 lg:min-h-[720px]">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full bg-background-50/15 px-4 py-2 text-xs font-label font-semibold uppercase tracking-[0.16em] text-background-50 ring-1 ring-background-50/30">
          Nuevo punto de venta
        </span>

        <h1 className="max-w-3xl text-[38px] font-semibold leading-[1.08] text-background-50 sm:text-[44px] md:text-[56px] lg:text-[60px]">
          Iokus ya está en Guatapé
        </h1>

        <p className="mt-5 max-w-xl text-base leading-relaxed text-background-100 md:text-lg">
          Museo del Zócalo · Local 408 · Abierto todos los días de 10:30 a. m. a 6:30 p. m.
        </p>

        <div className="mt-9 flex w-full max-w-sm flex-col items-stretch gap-3 sm:max-w-none sm:flex-row sm:items-center sm:justify-center">
          <Button
            href={MAPS_LINK}
            variant="primary"
            external
            fbEvent="FindLocation"
            fbLabel="body"
            className="px-7 py-3 text-base"
          >
            <i className="ri-map-pin-2-line text-lg" aria-hidden="true"></i>
            Cómo llegar
          </Button>
          <Button href="#encontrar" variant="light" className="px-7 py-3 text-base">
            Ver qué encontrarás
            <i className="ri-arrow-down-line text-lg" aria-hidden="true"></i>
          </Button>
        </div>

        <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-sm font-label font-semibold text-foreground-900">
          <i className="ri-star-fill text-primary-600" aria-hidden="true"></i>
          5,0 · 74 reseñas en Google
        </div>
      </div>
    </section>
  );
}